import { LoadingButton } from "@mui/lab";
import useRankbonus from "../rankBonus/hooks/useRankbonus";
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { BodyRow } from "src/components/custom-table";
import DataHandlerList from "src/components/data-handler/list";
import EmptyTable from "src/components/emptyTable";
import Map from "src/components/map";

import Translate from "src/components/translate";
import useLevel from "./hooks/useLevel";

const LevelSettings = () => {


  const { state, handleUpdate, onSubmit } = useLevel();
  const { state: rankState } = useRankbonus(); 

  const { data, ...dataProps } = state;
   const { data: rankList } = rankState;
//    console.log("rankstate",rankState);


  return (
    <>
      <DataHandlerList dataProps={{ ...dataProps }}>
        <Table>
          <TableHead >
            <TableRow >
               <TableCell>
                <Translate> Rank</Translate>
              </TableCell>
              <TableCell>
                <Translate> Level 1 (%)</Translate>
              </TableCell>
              <TableCell>
          
                Level 2 (%)
              </TableCell>
               <TableCell>
                <Translate> Level 3 (%)</Translate>
              </TableCell>
               <TableCell>
                <Translate> Level 4 (%)</Translate>
              </TableCell>
               <TableCell>
                <Translate> Level 5 (%)</Translate>
              </TableCell>
               <TableCell>
                <Translate> Level 6 (%)</Translate>
              </TableCell>
               <TableCell>
                <Translate> Level 7 (%)</Translate>
              </TableCell>
               <TableCell>
                <Translate> Level 8 (%)</Translate>
              </TableCell>
               <TableCell>
                <Translate> Level 9 (%)</Translate>
              </TableCell>
               <TableCell>
                 Level 10 (%)
                {/* <Translate> Level 10%</Translate> */}
              </TableCell>
              
            </TableRow>
          </TableHead>
          <TableBody>
            <Map
              list={data}
              render={(item) => (
                <Row
                  key={item.id}
                  {...item}
                  onSubmit={onSubmit}
                  handleUpdate={handleUpdate}
                rankList={rankList}
                  {...item}
                />
              )}
            />
          </TableBody>
        </Table>

        <Box textAlign="right">
          <Stack alignItems="flex-end" sx={{ mt: 3 }}>
            <LoadingButton onClick={onSubmit} type="submit" variant="contained">
              <Translate>{"settings.network.update"}</Translate>
            </LoadingButton>
          </Stack>
        </Box>
      </DataHandlerList>
    </>
  );
};

const Row = ({rankList, id, level_1,level_2,level_3,level_4,level_5,level_6,level_7,level_8,level_9,level_10, handleUpdate,rank_id}) => {

const rankName =
  rankList?.find((item) => item.id === rank_id)?.rank_name || null;
  return (
    <TableRow>
 <TableCell>
        <TextField type="text" size="small" value={rankName} disabled sx={{width:"200px"}} />
      </TableCell>
      <TableCell>
<LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={level_1}
          name="level_1"
        />      </TableCell>
      <TableCell>
        <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={level_2}
          name="level_2"
        />
      </TableCell>
      <TableCell>
     
        <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={level_3}
          name="level_3"
        />
    
      </TableCell>
      <TableCell>
   
        <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={level_4}
          name="level_4"
        />
      </TableCell>
     
      <TableCell>
        <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={level_5}
          name="level_5"
        />
      </TableCell>
     
      <TableCell>
   
        <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={level_6}
          name="level_6"
        />
     
      </TableCell>
      <TableCell>
 
        <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={level_7}
          name="level_7"
        />
      </TableCell>
  
   
       <TableCell>
        <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={level_8}
          name="level_8"
        />
      </TableCell>
      <TableCell>
        <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={level_9}
          name="level_9"
        />
      </TableCell>
      <TableCell>
        <LoadingTextField
          handleUpdate={handleUpdate(id)}
          value={level_10}
          name="level_10"
        />
      </TableCell>

    

    </TableRow>
  );
};

const LoadingTextField = ({ value, name, handleUpdate }) => {
  const [loading, setLoading] = useState(false);
  const onChange = (e) => {
    setLoading(true);
    handleUpdate(e);
  };

  return (
    <TextField
      onWheel={(e) => e.target.blur()}
      type="number"
      onChange={onChange}
      size="small"
      value={value}
      name={name}
    />
  );
};

export default LevelSettings;
